<script>
export default {
  props: {
    conferenceRoomUuid: {
      default: null,
      type: String,
    },
    statusBuild: {
      type: Number,
      default: 0,
    },
  },
  name: 'ConferenceStand',
  data() {
    return {
      busy: {
        fileUpload: false,
      },

      formDate: {
        date: null,
        timeStartedAt: null,
        timeEndedAt: null,
        started_at: null,
        ended_at: null,
      },
      labels: {
        ru: {
          labelHours: 'часы',
          labelMinutes: 'Минуты',
          labelSeconds: 'Секунды',
          labelIncrement: 'Повышение',
          labelDecrement: 'Уменьшать',
          labelSelected: 'Выбранное время',
          labelNoTimeSelected: 'Время проведения',
          labelNoDateSelected: 'Дата проведения',
          labelCloseButton: 'Закрыть',
        },
      },

      formFile: {
        video: null,
        model: null,
        photo: null,
        sphere360: null,
        pdf: null,
        audio: null,
        presentation: null,
      },

      form: {
        leader: null,
        conferenceModelUuid: null,
        modelFile: null,
        modelTextureFile: null,
        presentationFile: null,
        conferenceModelEditUuid: '',
        conferenceModelEditDescription: '',
        conferenceModelEditLabel: '',
        conferenceFileEditUuid: '',
        conferenceFileEditLabel: '',
      },

      fields: {
        video: [
          {
            key: 'file_path',
            label: 'file_path',
            class: 'align-middle',
          },
          {
            key: 'file_label',
            label: 'file_label',
            class: 'align-middle',
          },
          {
            key: 'file_type',
            label: 'file_type',
            class: 'align-middle',
          },
          {
            key: 'file_extension',
            label: 'file_extension',
            class: 'align-middle',
          },
          {
            key: 'file_name',
            label: 'file_name',
            class: 'align-middle',
          },
          {
            key: 'actions',
            label: 'Действия',
            class: 'actions align-middle text-center',
          },
        ],
        model: [
          {
            key: 'description',
            label: 'Имя файла / Описание',
            class: 'align-top',
          },
          // {
          //   key: "view_model",
          //   label: "Просмотр",
          //   class: "align-middle",
          // },
          {
            key: 'textures',
            label: 'Текстуры',
            class: 'align-middle',
          },
          {
            key: 'actions',
            label: 'Действия',
            class: 'align-middle',
          },
        ],
        photo: [
          {
            key: 'key',
            label: 'Имя',
          },
          {
            key: 'actions',
            label: 'Действия',
            class: 'align-middle',
          },
        ],
        sphere360: [
          {
            key: 'key',
            label: 'Имя',
          },
          {
            key: 'actions',
            label: 'Действия',
            class: 'align-middle',
          },
        ],
        pdf: [
          {
            key: 'key',
            label: 'Имя',
          },
          {
            key: 'actions',
            label: 'Действия',
            class: 'align-middle',
          },
        ],
        audio: [
          {
            key: 'key',
            label: 'Имя',
          },
          {
            key: 'actions',
            label: 'Действия',
            class: 'align-middle',
          },
        ],
        common: [
          {
            key: 'file_label',
            label: 'file_label',
            class: 'align-middle',
          },
          {
            key: 'file_path',
            label: 'file_path',
            class: 'align-middle',
          },
          {
            key: 'file_label',
            label: 'file_label',
            class: 'align-middle',
          },
          {
            key: 'file_type',
            label: 'file_type',
            class: 'align-middle',
          },
          {
            key: 'file_extension',
            label: 'file_extension',
            class: 'align-middle',
          },
          // {
          //   key: "file_name",
          //   label: "file_name",
          //   class: "align-middle",
          // },
          {
            key: 'actions',
            label: 'Действия',
            class: 'actions align-middle text-center',
          },
        ],
      },

      current: {
        conferenceRoomStandUuid: null,
      },

      modelPreview: {
        model: '',
        texture: '',
        textures: [],
      },
      pdfPreview: '',
      conference_stand_uuid: '',
    }
  },
  computed: {
    titleFilterAnalyticDate() {
      let returnDate = 'Не указано'
      if (this.formDate.started_at && this.formDate.started_at !== '') {
        returnDate = this.formDate.started_at.toLocaleDateString()
      }
      if (this.formDate.ended_at && this.formDate.ended_at !== '') {
        returnDate += ' - ' + this.formDate.ended_at.toLocaleDateString()
      }
      return returnDate
    },
    maxAnalyticDateStart() {
      let returnDate = new Date()
      if (this.formDate.ended_at && this.formDate.ended_at !== '') {
        returnDate = this.formDate.ended_at
      }
      return returnDate
    },
    minAnalyticDateEnd() {
      let returnDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      if (this.formDate.started_at && this.formDate.start !== '') {
        returnDate = this.formDate.started_at
      }
      return returnDate
    },
    getCurrentConferenceRoomStand() {
      let currentConferenceRoomStand = this.$store.getters.getCurrentConferenceRoomStand
      return currentConferenceRoomStand ?? {}
    },
    getCurrentConferenceRoom() {
      if (this.getCurrentConferenceRoomStand.conference_room) {
        return this.getCurrentConferenceRoomStand.conference_room
      } else return {}
    },
    getCurrentConferenceStand() {
      if (this.getCurrentConferenceRoomStand.conference_stand) {
        return this.getCurrentConferenceRoomStand.conference_stand
      } else return {}
    },
    getCurrentConferenceUser() {
      if (this.getCurrentConferenceRoomStand.conference_user) {
        return this.getCurrentConferenceRoomStand.conference_user
      } else return {}
    },
    // getConferencePresentations() {
    //   if (this.getCurrentConferenceRoomStand.conference_presentations) {
    //     return this.getCurrentConferenceRoomStand.conference_presentations
    //   } else return []
    // },
    getConferenceFiles() {
      if (this.getCurrentConferenceRoomStand.conference_files) {
        return this.getCurrentConferenceRoomStand.conference_files
      } else return []
    },
    getConferenceModels() {
      if (this.getCurrentConferenceRoomStand.conference_models) {
        return this.getCurrentConferenceRoomStand.conference_models
      } else return []
    },
    getCurrentUser() {
      if (this.getCurrentConferenceUser.user) {
        return this.getCurrentConferenceUser.user
      } else return {}
    },
    userOptions() {
      return this.$store.getters.getConferenceUsers
    },

    getConferenceRooms() {
      return this.$store.getters.getConferenceRooms
    },
    isConferenceRoomStarted() {
      return !!this.getConferenceRooms.find(
        (item) => item.uuid === this.conferenceRoomUuid && item.status === 'activated',
      )
    },
    isConferenceRoomOtherStarted() {
      return !!this.getConferenceRooms.find((item) => item.status === 'activated')
    },
    busyFileUpload() {
      return this.busy.fileUpload
    },
    isCompanyBuild() {
      return this.statusBuild === 1
    },
    getConferenceFilePhotos() {
      return this.getConferenceFiles.filter((itemFile) => itemFile.file_type === 'photo') || []
    },
    getConferenceFilePdfs() {
      return this.getConferenceFiles.filter((itemFile) => itemFile.file_type === 'pdf') || []
    },
    getConferenceFileAudios() {
      return this.getConferenceFiles.filter((itemFile) => itemFile.file_type === 'audio') || []
    },
    getConferenceFileVideos() {
      return this.getConferenceFiles.filter((itemFile) => itemFile.file_type === 'video') || []
    },
  },
  created() {
    // this.fetchConferenceRoomStands()
    // this.form.leader = this.getConferenceRoomStand
  },

  watch: {
    '$store.getters.getConferenceRoomStands'() {
      if (this.current.conferenceRoomStandUuid) {
        let conferenceRoomStand = this.getConferenceRoomStand(this.current.conferenceRoomStandUuid)
        this.$store.commit('setConferenceRoomStand', conferenceRoomStand)
      }
    },
    'current.conferenceRoomStandUuid'(newValue) {
      if (newValue) {
        let conferenceRoomStand = this.getConferenceRoomStand(this.current.conferenceRoomStandUuid)
        this.$store.commit('setConferenceRoomStand', conferenceRoomStand)
      } else {
        this.$store.commit('setConferenceRoomStand', {})
      }
    },
    'form.leader'(newValue) {
      if (newValue) {
        this.saveStand()
      }
    },
    'form.presentationFile'(newValue) {
      if (newValue) {
        this.uploadFilePresentation(newValue)
      }
    },
    'form.modelFile'(newValue) {
      if (newValue) {
        this.uploadFileModel(newValue)
      }
    },
    'form.modelTextureFile'(newValue) {
      if (newValue) {
        this.uploadFileModelTexture(newValue)
      }
    },

    'formFile.video'(newValue) {
      if (newValue) {
        this.uploadConferenceFile(newValue, 'video')
      }
    },
    'formFile.model'(newValue) {
      if (newValue) {
        this.uploadConferenceFile(newValue, 'model')
      }
    },
    'formFile.texture'(newValue) {
      if (newValue) {
        this.uploadConferenceFile(newValue, 'texture', this.form.conferenceModelUuid)
      }
    },
    'formFile.photo'(newValue) {
      if (newValue) {
        this.uploadConferenceFile(newValue, 'photo')
      }
    },
    'formFile.sphere360'(newValue) {
      if (newValue) {
        this.uploadConferenceFile(newValue, 'sphere360')
      }
    },
    'formFile.pdf'(newValue) {
      if (newValue) {
        this.uploadConferenceFile(newValue, 'pdf')
      }
    },
    'formFile.audio'(newValue) {
      if (newValue) {
        this.uploadConferenceFile(newValue, 'audio')
      }
    },
    'formFile.presentation'(newValue) {
      if (newValue) {
        this.uploadConferenceFile(newValue, 'presentation')
      }
    },
  },
  methods: {
    getConferenceFilesByType(fileType) {
      return (
        this.getConferenceFiles.filter((itemFile) => {
          return itemFile.file_type === fileType
        }) || []
      )
    },
    uploadConferenceFile(file, fileType) {
      this.busy.fileUpload = true
      const formData = new FormData()
      formData.set('file', file)
      formData.set('conference_room_stand_uuid', this.getCurrentConferenceRoomStand.uuid)
      formData.set('file_type', fileType)
      axios.post('/webapi/conference/file', formData).finally(() => {
        this.fetchConferenceRoomStands()
      })
    },
    uploadConferenceFileChild(file, fileType, parent_uuid) {
      this.busy.fileUpload = true
      const formData = new FormData()
      formData.set('file', file)
      formData.set('conference_room_stand_uuid', this.getCurrentConferenceRoomStand.uuid)
      formData.set('file_type', fileType)
      formData.set('parent_uuid', parent_uuid)
      axios.post('/webapi/conference/file/child/' + parent_uuid, formData).finally(() => {
        this.fetchConferenceRoomStands()
      })
    },
    fetchConferenceRooms() {
      this.$store.dispatch('fetchConferenceRooms')
    },
    makeToast(body = 'Ничего не произошло', variant = 'success', title = 'Уведомление') {
      this.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 9000,
        appendToast: false,
        variant: variant,
        toaster: 'b-toaster-bottom-center',
      })
    },
    conferenceModelEdit(conferenceModel) {
      if (this.form.conferenceModelEditUuid === '') {
        this.form.conferenceModelEditUuid = conferenceModel.uuid
        this.form.conferenceModelEditDescription = conferenceModel.description
        this.form.conferenceModelEditLabel = conferenceModel.file_label
      } else if (this.form.conferenceModelEditUuid !== conferenceModel.uuid) {
        this.$store.commit('setConferenceModelDescription', {
          uuid: this.form.conferenceModelEditUuid,
          description: this.form.conferenceModelEditDescription,
          file_label: this.form.conferenceModelEditLabel,
        })
        this.form.conferenceModelEditUuid = conferenceModel.uuid
        this.form.conferenceModelEditDescription = conferenceModel.description
        this.form.conferenceModelEditLabel = conferenceModel.file_label
      }
    },
    conferenceFileEdit(conferenceFile) {
      if (this.form.conferenceFileEditUuid === '') {
        this.form.conferenceFileEditUuid = conferenceFile.uuid
        this.form.conferenceFileEditLabel = conferenceFile.file_label
      } else if (this.form.conferenceFileEditUuid !== conferenceFile.uuid) {
        this.$store.commit('updateConferenceFile', {
          uuid: this.form.conferenceFileEditUuid,
          file_label: this.form.conferenceFileEditLabel,
        })
        this.form.conferenceFileEditUuid = conferenceFile.uuid
        this.form.conferenceFileEditLabel = conferenceFile.file_label
      }
    },
    conferenceModelSave(itemModel) {
      this.busy.fileUpload = true
      axios
        .patch(`/webapi/conference/model/${this.form.conferenceModelEditUuid}`, {
          description: itemModel.description,
          file_label: itemModel.file_label,
        })
        .finally(() => {
          this.form.conferenceModelEditUuid = ''
          this.form.conferenceModelEditDescription = ''
          this.form.conferenceModelEditLabel = ''
          this.fetchConferenceRoomStands()
        })
    },
    conferenceFileUpdate(itemFile) {
      this.busy.fileUpload = true
      axios
        .patch(`/webapi/conference/file/${this.form.conferenceFileEditUuid}`, {
          file_label: itemFile.file_label,
        })
        .finally(() => {
          this.form.conferenceFileEditUuid = ''
          this.form.conferenceFileEditLabel = ''
          this.fetchConferenceRoomStands()
        })
    },
    uploadFilePresentation(file) {
      this.busy.fileUpload = true
      const formData = new FormData()
      formData.set('file', file)
      formData.set('conference_room_stand_uuid', this.getCurrentConferenceRoomStand.uuid)
      axios.post('/webapi/conference/presentation', formData).finally(() => {
        this.fetchConferenceRoomStands()
      })
    },
    uploadFileModel(file) {
      this.busy.fileUpload = true
      const formData = new FormData()
      formData.set('file', file)
      formData.set('conference_room_stand_uuid', this.getCurrentConferenceRoomStand.uuid)
      axios.post('/webapi/conference/model', formData).finally(() => {
        this.fetchConferenceRoomStands()
      })
    },
    uploadFileModelTexture(file) {
      this.busy.fileUpload = true
      const formData = new FormData()
      formData.set('file', file)
      formData.set('conference_room_stand_uuid', this.getCurrentConferenceRoomStand.uuid)
      // formData.set("conference_model_uuid", this.form.conferenceModelUuid)
      axios.post('/webapi/conference/model/texture/' + this.form.conferenceModelUuid, formData).finally(() => {
        this.fetchConferenceRoomStands()
      })
    },
    deleteConferenceFile(uuid) {
      this.busy.fileUpload = true
      axios.delete('/webapi/conference/file/' + uuid).finally(() => {
        this.fetchConferenceRoomStands()
      })
    },
    deleteFileModel(uuid) {
      this.busy.fileUpload = true
      axios.delete('/webapi/conference/model/' + uuid).finally(() => {
        this.fetchConferenceRoomStands()
      })
    },
    deleteFileModelTexture(uuid) {
      this.busy.fileUpload = true
      axios.delete('/webapi/conference/model/texture/' + uuid).finally(() => {
        this.fetchConferenceRoomStands()
      })
    },
    clearRoomStand() {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Действительно очистить стенд?', {
          title: 'Подтверждение очистки стенда',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Очистить',
          cancelTitle: 'Отменить',
          hideHeaderClose: true,
          centered: true,
          bodyClass: 'h5',
          titleClass: 'font-weight-bold',
          headerClass: 'border-bottom-0',
          footerClass: 'border-top-0',
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            this.$store
              .dispatch('clearConferenceRoomStand', {
                conference_room_stand_uuid: this.getCurrentConferenceRoomStand.uuid,
              })
              .then(() => {
                // this.$bvModal.hide("screen-modal")
                this.fetchConferenceRoomStands()
              })
          }
        })
    },
    fetchConferenceRoomStands() {
      this.$store.dispatch('fetchConferenceRoomStands').finally(() => {
        this.busy.fileUpload = false
        this.form.modelFile = null
        this.form.presentationFile = null
      })
    },
    getConferenceRoomStand(conferenceStandUuid) {
      let conferenceRoomStand
      conferenceRoomStand = this.$store.getters.getConferenceRoomStand(conferenceStandUuid)
      return conferenceRoomStand ?? {conference_stand_uuid: conferenceStandUuid}
    },
    saveStand() {
      this.$store
        .dispatch('addConferenceRoomStand', {
          conference_room_uuid: this.conferenceRoomUuid,
          conference_user_uuid: this.form.leader.uuid,
        })
        .then(() => {
          this.fetchConferenceRoomStands()
        })
    },
    updateConferenceRoomStand() {
      this.$store
        .dispatch('putConferenceRoomStand', {
          conference_user_uuid: this.form.leader.uuid,
          conference_room_stand_uuid: this.getCurrentConferenceRoomStand.uuid,
        })
        .then(() => {
          this.fetchConferenceRoomStands()
        })
    },
    loadModel(conference_stand_uuid) {
      const uploadingFile = new FormData()
      uploadingFile.set('model', this.form.modelFile)
      return axios.post(`/webapi/conference/stand/${conference_stand_uuid}/model`, uploadingFile)
    },
    loadPresentation() {
      const uploadingFile = new FormData()
      uploadingFile.set('presentation', this.form.presentationFile)
      return axios.post(`/webapi/conference/presentation/${this.current.conferenceRoomStandUuid}`, uploadingFile)
    },
    loadModelTexture(data) {
      const uploadingFile = new FormData()
      uploadingFile.set('texture', this.form.textureFile)
      return axios.post(
        `/webapi/conference/stand/${data.item.conference_stand_uuid}/${data.item.model_uuid}/texture`,
        uploadingFile,
      )
    },
    openModelPreview(modelPath, textures) {
      this.modelPreview.model = '/public/' + modelPath
      if (textures[0]) {
        this.modelPreview.texture = '/public/' + textures[0].file_path
        textures.forEach((texture) => {
          this.modelPreview.textures.push('/public/' + texture.file_path)
        })
      }
      this.$bvModal.show('modal-model-preview')
    },
    openPdfPreview(pdfPath) {
      this.pdfPreview = pdfPath
      this.$bvModal.show('modal-pdf-preview')
    },
    closeModelPreview() {
      this.$bvModal.hide('modal-model-preview')
      this.modelPreview.model = ''
      this.modelPreview.texture = ''
      this.modelPreview.textures = []
    },
    closePdfPreview() {
      this.$bvModal.hide('modal-pdf-preview')
      this.modelPreview.model = ''
      this.modelPreview.texture = ''
      this.modelPreview.textures = []
    },
    openScreenModal(conferenceRoomStandUuid) {
      this.conference_stand_uuid = conferenceRoomStandUuid
      this.current.conferenceRoomStandUuid = conferenceRoomStandUuid
      this.$bvModal.show('screen-modal')
    },
    closeScreenModal() {
      this.$bvModal.hide('screen-modal')
      this.current.conferenceRoomStandUuid = null
    },
    selectLeader(leader) {
      this.form.leader = leader
    },

    conferenceRoomDeactivate() {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Действительно деактивировать конференцию?', {
          title: 'Подтверждение деактивации мероприятия',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Деактивировать',
          cancelTitle: 'Отменить',
          hideHeaderClose: true,
          centered: true,
          bodyClass: 'h5',
          titleClass: 'font-weight-bold',
          headerClass: 'border-bottom-0',
          footerClass: 'border-top-0',
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            axios.patch(`/webapi/conference/room/${this.conferenceRoomUuid}/deactivate`, {}).then(() => {
              this.makeToast('Конференция деактивирована')
              this.fetchConferenceRooms()
            })
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
    conferenceRoomActivate() {
      if (this.isConferenceRoomOtherStarted) {
        this.makeToast(
          'Вы не можете активировать этот зал, т.к. в настоящий момент активно мероприятие в другом зале. Чтобы продолжить, дождитесь окончания мероприятия или деактивируйте активный зал.',
          'danger',
          'Ошибка активации',
        )
        return
      }
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Действительно активировать конференцию?', {
          title: 'Подтверждение активации мероприятия',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: 'Активировать',
          cancelTitle: 'Отменить',
          hideHeaderClose: true,
          centered: true,
          bodyClass: 'h5',
          titleClass: 'font-weight-bold',
          headerClass: 'border-bottom-0',
          footerClass: 'border-top-0',
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            axios.patch(`/webapi/conference/room/${this.conferenceRoomUuid}/activate`, {}).then(() => {
              this.makeToast('Конференция активирована')
              this.fetchConferenceRooms()
            })
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
    clearRoomStands() {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Действительно очистить все стенды в этом зале?', {
          title: 'Подтверждение очистки стендов',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Очистить',
          cancelTitle: 'Отменить',
          hideHeaderClose: true,
          centered: true,
          bodyClass: 'h5',
          titleClass: 'font-weight-bold',
          headerClass: 'border-bottom-0',
          footerClass: 'border-top-0',
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            axios.delete('/webapi/conference/room/stand/all/' + this.conferenceRoomUuid).then(() => {
              this.fetchConferenceRoomStands()
            })
          }
        })
    },
  },
}
</script>

<style>
.btn-stand {
  width: 34px;
  height: 34px;
}
</style>
